import { useMemo } from 'react'

import useSWR from 'swr'
import { useRouter } from 'next/router'
import { featureCollection } from '@turf/helpers'
import { FORECAST } from '@avcan/constants/products'

import client from 'clients/forecasts'

export const useLoadingArchivedForecasts = date => {
    const { areas, metadata } = useArchivedForecasts(date)

    const isLoading = !areas || !metadata

    return {
        isLoading,
    }
}

export function useArchivedForecasts(date) {
    const { locale } = useRouter()
    const metadataKey = ['metadata', locale, date]
    const { data: metadata } = useSWR(metadataKey, () => client.metadataByDate(date, locale))

    const areaKey = ['areas', locale, date]
    const { data: areas } = useSWR(areaKey, () => client.areasByDate(date, locale))
    const formattedAreas = useMemo(() => {
        if (!metadata || !areas) {
            return null
        }
        const features = metadata.map(item => createFeature(item, areas)).filter(Boolean)

        return featureCollection(features)
    }, [metadata, areas])

    // Note that forecast details are fetched on the fly when opening a side panel
    return {
        metadata,
        areas: formattedAreas,
    }
}

// Helpers
function createFeature(item, areas) {
    const area = areas.features.find(area => area.properties.id === item.area.id)

    if (!area) {
        return
    }

    const { product, owner, url } = item
    const extra = owner.isExternal
        ? { url }
        : {
              product: FORECAST,
              id: product.id,
          }

    return {
        ...area,
        properties: {
            ...area.properties,
            ...extra,
        },
    }
}
